import {
  Checkbox, FormControl, FormControlLabel, FormGroup, MenuItem, Select, Stack, TextField, ToggleButton, ToggleButtonGroup,
} from '@mui/material';
import { useCallback } from 'react';
import CloseButton from '../Buttons/Close';
import BlockData from '../../models/BlockData';
import BlockType from '../../models/BlockType';
import { URLOpenType } from '../../models/URLOpenType';
import { URLTargetType } from '../../models/URLTargetType';
import LinkData from '../../models/LinkData';

interface Props {
  link: LinkData;
  blockData: BlockData[];
  hideRemoveButton?: boolean;
  hideTitle?: boolean;
  onRemoveBlock?: () => void;
  onChangeURLTitle?: (title: string) => void;
  onChangeLink?: (link: string) => void;
  onSelectBlock?: (selected: string) => void;
  onChangeTargetType?: (target: any) => void;
  onChangeOpenType?: (checked: boolean) => void;
}

function LinkComponent({
  link,
  blockData,
  hideRemoveButton = false,
  hideTitle = false,
  onRemoveBlock,
  onChangeURLTitle,
  onChangeLink,
  onSelectBlock,
  onChangeTargetType,
  onChangeOpenType,
}: Props) {
  const blockOptions = blockData.map((block, index) => (
    <MenuItem value={`#${block.id}`} key={block.id}>{`第${index}ブロック：${BlockType.describe(block.type)}`}</MenuItem>
  ));

  const matchBlockId = useCallback(
    (url?: string) => blockData.some(((item) => `#${item.id}` === url)),
    [blockData],
  );

  return (
    <Stack spacing={2} sx={{ border: '1px dashed lightGray', p: 2, position: 'relative' }}>
      {!hideRemoveButton && <CloseButton updateHandler={onRemoveBlock} />}
      {!hideTitle && (
        <TextField
          required
          label="テキスト"
          defaultValue={link.title}
          onChange={(event) => onChangeURLTitle(event.target.value)}
          size="small"
        />
      )}
      <ToggleButtonGroup
        color="primary"
        value={link.linkData.targetType}
        exclusive
        onChange={(_, newValue) => {
          if (newValue) {
            onChangeTargetType(newValue);
          }
        }}
        size="small"
      >
        <ToggleButton value={URLTargetType.INTERNAL}>ページ内リンク</ToggleButton>
        <ToggleButton value={URLTargetType.EXTERNAL}>直接URLを入力</ToggleButton>
      </ToggleButtonGroup>

      { link.linkData.targetType === URLTargetType.INTERNAL
          && (
            <>
              <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                <Select
                  value={matchBlockId(link.linkData.url) ? link.linkData.url : ''}
                  onChange={(event) => onSelectBlock(event.target.value)}
                  displayEmpty
                >
                  <MenuItem value="" key="">
                    <em>選択してください</em>
                  </MenuItem>
                  {blockOptions}
                </Select>
              </FormControl>
            </>
          )}

      { link.linkData.targetType === URLTargetType.EXTERNAL
          && (
            <>
              <TextField
                required
                label="リンク"
                defaultValue={link.linkData.url}
                onChange={(event) => onChangeLink(event.target.value)}
                size="small"
              />
              <FormGroup>
                <FormControlLabel
                  control={(
                    <Checkbox
                      checked={link.linkData.openType === URLOpenType.NEW_TAB}
                      onChange={(event) => onChangeOpenType(event.target.checked)}
                    />
                  )}
                  label="別タブで開く"
                />
              </FormGroup>
            </>
          )}

    </Stack>
  );
}

export default LinkComponent;
